import { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Button from '../base/Button';

export default function Navigation() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleContactClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    navigate('/contact');
    setTimeout(() => {
      const element = document.getElementById('quote-section');
      if (element) {
        const offset = 80;
        const elementPosition = element.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - offset;
        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      }
    }, 100);
  };

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'Window Tinting', path: '/window-tinting' },
    { name: 'Mobile Tinting', path: '/mobile-tinting' },
    { name: 'Commercial Tinting', path: '/commercial-tinting' },
    { name: 'Headlight & Taillight', path: '/headlight-taillight-tinting' },
    { name: 'Vehicle Decals', path: '/vehicle-decals' },
    { name: 'Contact', path: '/contact' },
  ];

  return (
    <nav className="fixed w-full top-0 z-50 bg-white shadow-lg py-4 max-md:py-2">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between gap-4">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-3 group flex-shrink-0">
            <img
              src="https://static.readdy.ai/image/c01416e64dc18fdf8a1396f4374d4d9c/011a41a572be26a3d3db871d15682773.jpeg"
              alt="U.B.K Window Tint Services"
              className="h-16 max-md:h-12 w-auto transition-transform duration-300 group-hover:scale-105"
            />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center space-x-6 xl:space-x-8 flex-1 justify-center">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`font-medium transition-colors duration-300 whitespace-nowrap text-sm ${
                  location.pathname === link.path
                    ? 'text-primary'
                    : 'text-gray-700 hover:text-primary'
                }`}
              >
                {link.name}
              </Link>
            ))}
          </div>

          {/* CTA Buttons */}
          <div className="hidden lg:flex items-center space-x-3 flex-shrink-0">
            <button 
              onClick={() => window.location.href = 'tel:4438000348'}
              className="font-medium whitespace-nowrap cursor-pointer text-gray-700 hover:text-primary text-sm"
            >
              <i className="ri-phone-line mr-2"></i>
              (443) 800-0348
            </button>
            <Button size="md" onClick={handleContactClick}>Request Appointment</Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="lg:hidden p-2 rounded-lg text-gray-700 flex-shrink-0"
            aria-label="Toggle menu"
          >
            <div className="w-6 h-6 flex items-center justify-center">
              <i className={`text-2xl ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
            </div>
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="lg:hidden mt-4 pb-4 bg-white rounded-lg shadow-xl">
            <div className="flex flex-col space-y-3 p-4">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  onClick={() => setIsMobileMenuOpen(false)}
                  className={`py-2 px-4 rounded-lg font-medium transition-colors whitespace-nowrap ${
                    location.pathname === link.path
                      ? 'bg-primary text-white'
                      : 'text-gray-700 hover:bg-gray-100'
                  }`}
                >
                  {link.name}
                </Link>
              ))}
              <button
                onClick={() => window.location.href = 'tel:4438000348'}
                className="py-2 px-4 text-gray-700 font-medium whitespace-nowrap cursor-pointer text-left"
              >
                <i className="ri-phone-line mr-2"></i>
                (443) 800-0348
              </button>
              <Button fullWidth onClick={(e) => { setIsMobileMenuOpen(false); handleContactClick(e); }}>Request Appointment</Button>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}
